@for (item of items; track item; let idx = $index; let last = $last) {
  <button
    role="button"
    class="btn btn-sm badge bg-primary text-primary-fg p-2 my-1"
    [class.me-2]="!last"
    (click)="onClick(idx)"
    >
    {{ item.name }} <i class="fa-regular fa-xmark ms-2"></i>
</button>
}
